angular.module('dpw.components')
    .component('dpwSecondaryNavGroup', {
        bindings: {
            data: '<',
            enableLastItemAsCta: '<'
        },
        templateUrl: 'dpw-secondary-nav-group.html',
        controller: ['helpers', function (helpers) {
            var self = this;

            Object.defineProperty(self, 'items', {
               get: function () {
                   var data = self.data || {};
                   return data.items || [];
               }
            });

            self.isFirst = function (index) {
                return index === 0;
            }

            self.isLast = function (index) {
                return index === self.items.length - 1;
            };

            self.isExternalUrl = function (url) {
                return helpers.isAbsoluteUrl(url);
            }

            self.isCtaItem = function (index) {
                return self.enableLastItemAsCta && self.isLast(index) && !self.isFirst(index);
            }

            self.onClick = function (event, item) {
                if (item.onClick) {
                    item.onClick(event);
                }
            };
        }]
    });
